import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import PartnersSection from './components/PartnersSection';
import AboutSection from './components/AboutSection';
import ProductsSection from './components/ProductsSection';
import HardwareSection from './components/HardwareSection';
import CasesSection from './components/CasesSection';
import CoreAdvantageSection from './components/CoreAdvantageSection';
import TestimonialsSection from './components/TestimonialsSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ProductsSection />
        <HardwareSection />
        <CasesSection />
        <CoreAdvantageSection />
        <TestimonialsSection />
        <PartnersSection />
      </main>
      <Footer />
    </div>
  );
}